// import React, { PureComponent } from 'react';
import {
  BarChart,
  Bar,
  // Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import styled from "styled-components";

const data = [
  {
    name: "JAN",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "FEB",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "MAR",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "APR",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "MAY",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "JUN",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "JULY",
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
  {
    name: "AUG",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "SEP",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "OCT",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "NOV",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "DEC",
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

const BarChartStyle = styled.span`
  .recharts-legend-wrapper,
  .recharts-cartesian-grid-horizontal,
  .recharts-cartesian-grid-vertical,
  .recharts-cartesian-axis-line,
  .recharts-layer line {
    display: none;
  }
  .recharts-cartesian-axis-ticks {
    font-size: 14px;
  }
`;

// Custom Tooltip Component
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const credit = payload.find((p) => p.dataKey === "credit")?.value || 0;
    const debit = payload.find((p) => p.dataKey === "debit")?.value || 0;

    return (
      <div
        style={{
          backgroundColor: "white",
          border: "1px solid #eee",
          borderRadius: "10px",
          padding: "12px 16px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          fontSize: "13px",
        }}
      >
        <p style={{ margin: "0 0 8px 0", fontWeight: "600", color: "#383838" }}>
          {label}
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <p style={{ margin: "0", color: "var(--color-primary)", fontWeight: "500" }}>
            Credit: ₦{Number(credit).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </p>
          <p style={{ margin: "0", color: "#82C1D3", fontWeight: "500" }}>
            Debit: ₦{Number(debit).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </p>
        </div>
      </div>
    );
  }
  return null;
};

export const BarChartComp = ({ chartData }) => {
  const formatYAxis = (value) => {
    if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
    if (value >= 1000) return `${(value / 1000).toFixed(0)}k`;
    return value;
  };

  return (
    <BarChartStyle>
      <div style={{ width: "100%", height: 300 }}>
        <ResponsiveContainer>
          <BarChart
            data={chartData ?? data}
            margin={{
              top: 10,
              right: 10,
              left: 0,
              bottom: 0,
            }}
            barGap={8}
          >
            <CartesianGrid vertical={false} stroke="#f0f0f0" />
            <XAxis 
              dataKey="name" 
              axisLine={false} 
              tickLine={false}
              tick={{ fill: "#666", fontSize: 12 }}
              dy={10}
            />
            <YAxis 
              axisLine={false} 
              tickLine={false}
              tick={{ fill: "#999", fontSize: 11 }}
              tickFormatter={formatYAxis}
              width={40}
            />
            <Tooltip
              content={<CustomTooltip />}
              cursor={{ fill: "rgba(0,0,0,0.03)" }}
            />
            <Bar 
              dataKey="credit" 
              fill="var(--color-primary)" 
              radius={[4, 4, 0, 0]} 
              barSize={12}
            />
            <Bar 
              dataKey="debit" 
              fill="#82C1D3" 
              radius={[4, 4, 0, 0]} 
              barSize={12}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </BarChartStyle>
  );
};
